import { useQuery } from "@tanstack/react-query"
import sdk from "@/api/sdk"

export const useTrustedPartners = (loanId: string) => {
  return useQuery({
    queryKey: ["trustedPartners", loanId],
    queryFn: async () => {
      const response = await sdk.TrustedPartnerQuery({ loanId })
      return response.trustedPartners
    },
    retry: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}
